'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteFeiseannaProperties = exports.payAccountBalance = exports.getEventsScoredByAdjudicators = exports.getEventTypes = exports.getEventLevels = exports.getUnpaidCompetitorsForFeis = exports.getGroupFeeForFeis = exports.getGroupFeesForFeis = exports.updateGroupFeesForFeis = exports.createGroupFeesForFeis = exports.deleteGroupFeesForFeis = exports.getFeis = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var getFeis = exports.getFeis = function getFeis(feis_id) {
  return function (dispatch, getState) {
    var feis = getState().getIn(['feiseanna', 'one', feis_id]);

    // prefer the cached version
    if (feis) return;

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id
      },
      types: ['GET_FEIS_START', 'GET_FEIS', 'GET_FEIS_ERROR']
    }));
  };
};

var deleteGroupFeesForFeis = exports.deleteGroupFeesForFeis = function deleteGroupFeesForFeis(feis_id, id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      id: id
    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/groupFees/' + id,
        method: 'DELETE'
      },
      types: ['DELETE_GROUP_FEES_START', 'DELETE_GROUP_FEES', 'DELETE_GROUP_FEES_ERROR']
    }));
  };
};

var createGroupFeesForFeis = exports.createGroupFeesForFeis = function createGroupFeesForFeis(feis_id, data) {
  return function (dispatch) {
    data.name = data.name.toLowerCase().split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');

    return dispatch(_defineProperty({
      feis_id: feis_id
    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/groupFees',
        method: 'POST',
        data: data
      },
      types: ['CREATE_GROUP_FEES_START', 'CREATE_GROUP_FEES', 'CREATE_GROUP_FEES_ERROR']
    }));
  };
};

var updateGroupFeesForFeis = exports.updateGroupFeesForFeis = function updateGroupFeesForFeis(feis_id, data) {
  return function (dispatch) {
    var id = data.id;
    data.name = data.name.toLowerCase().split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');

    return dispatch(_defineProperty({
      feis_id: feis_id,
      id: id
    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/groupFees/' + id,
        method: 'PUT',
        data: data
      },
      types: ['UPDATE_GROUP_FEES_START', 'UPDATE_GROUP_FEES', 'UPDATE_GROUP_FEES_ERROR']
    }));
  };
};

var getGroupFeesForFeis = exports.getGroupFeesForFeis = function getGroupFeesForFeis(feis_id) {
  return function (dispatch, getState) {
    var groupFees = getState().getIn(['feiseanna', 'groupFees', feis_id]);

    // prefer the cached version
    if (groupFees) return;

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/groupFees'
      },
      types: ['GET_GROUP_FEES_START', 'GET_GROUP_FEES', 'GET_GROUP_FEES_ERROR']
    }));
  };
};

var getGroupFeeForFeis = exports.getGroupFeeForFeis = function getGroupFeeForFeis(feis_id, groupFee_id) {
  return function (dispatch, getState) {
    var groupFees = getState().getIn(['feiseanna', 'groupFees', feis_id]).find(function (g) {
      return g.get('id') === groupFee_id;
    });

    // prefer the cached version
    if (groupFees) return;

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/groupFees/' + groupFee_id
      },
      types: ['GET_GROUP_FEE_START', 'GET_GROUP_FEE', 'GET_GROUP_FEE_ERROR']
    }));
  };
};

var getUnpaidCompetitorsForFeis = exports.getUnpaidCompetitorsForFeis = function getUnpaidCompetitorsForFeis(feis_id) {
  return function (dispatch, getState) {
    var params = { limit: 0, unpaid: true };

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/competitors',
        params: params
      },
      types: ['GET_UNPAID_COMPETITORS_FOR_FEIS_START', 'GET_UNPAID_COMPETITORS_FOR_FEIS', 'GET_UNPAID_COMPETITORS_FOR_FEIS_ERROR']
    }));
  };
};

var getEventLevels = exports.getEventLevels = function getEventLevels(feis_id) {
  return function (dispatch, getState) {
    var eventLevels = getState().getIn(['feiseanna', 'one', 'eventLevels', feis_id]);

    if (eventLevels) {
      return;
    }

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/event-levels'
      },
      types: ['GET_EVENT_LEVELS_START', 'GET_EVENT_LEVELS', 'GET_EVENT_LEVELS_ERROR']
    }));
  };
};

var getEventTypes = exports.getEventTypes = function getEventTypes(feis_id) {
  return function (dispatch, getState) {
    var eventTypes = getState().getIn(['feiseanna', 'one', 'eventTypes', feis_id]);

    if (eventTypes) {
      return;
    }

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/event-types'
      },
      types: ['GET_EVENT_TYPES_START', 'GET_EVENT_TYPES', 'GET_EVENT_TYPES_ERROR']
    }));
  };
};

var getEventsScoredByAdjudicators = exports.getEventsScoredByAdjudicators = function getEventsScoredByAdjudicators(feis_id, adj_id) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      adj_id: adj_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/adjudicators/' + adj_id + '/events/persons/scores'
      },
      types: ['GET_EVENTS_SCORED_BY_ADJUDICATORS_START', 'GET_EVENTS_SCORED_BY_ADJUDICATORS', 'GET_EVENTS_SCORED_BY_ADJUDICATORS_ERROR']
    }));
  };
};

var payAccountBalance = exports.payAccountBalance = function payAccountBalance(feis_id, acct_id, data) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      acct_id: acct_id,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/' + acct_id + '/credits',
        method: 'POST',
        data: data
      },
      types: ['GET_PAYMENTS_FOR_ACCOUNT_START', 'GET_PAYMENTS_FOR_ACCOUNT', 'GET_PAYMENTS_FOR_ACCOUNT_ERROR']
    }));
  };
};

var deleteFeiseannaProperties = exports.deleteFeiseannaProperties = function deleteFeiseannaProperties(feis_id, propToDelete) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      propToDelete: propToDelete,
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/properties/' + propToDelete,
        method: 'DELETE'
      },
      types: ['DELETE_FEIS_PROPERTY_START', 'DELETE_FEIS_PROPERTY', 'DELETE_FEIS_PROPERTY_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/feiseanna/index.js
// module id = 66
// module chunks = 0